export default "data:application/font-woff;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMjI4NTc3M2U2YjRiMTcyZjA3ZDliNzc3YzgxYjA3NzUud29mZiI7"